/* 菜单返回backRouteId 对应模型列表路径 */
let menuconfig = {
  '28': 'appointment', // 活动报名
  '29': 'newlive', // 文旅直播
  '30': 'culturalorder', // 文化点单
  '31': 'culturedistribution', // 文化配送
  '32': 'information', // 文化资讯
  '43': 'culturemap', // 文化地图
  '50': 'travelguide', // 旅游攻略
  '51': 'digitalpavilion', // 场馆预览
  '52': 'live', // 本地视听
  '55': 'venue', // 场馆预订
  '58': 'delicacy', // 特色美食
  '59': 'homestayhotel', // 民宿酒店
  '60': 'culturalcommodity', // 文创商城
  '61': 'touristmarket', // 旅游集市
  '63': 'volunteer', // 志愿者
  '64': 'volunteercommunity', // 志愿者团队
  '65': 'volunteeractivity', // 志愿者活动
  '66': 'activitystyle', // 服务风采
  '69': 'managementdeclaration', // 管理申报
  '67': 'ticket', // 票务预订
  '68': 'cultureshow', // 群文展示
  '74': 'scenicspot', // 景点推荐
  '75': 'mailbox', // 旅游信箱
  '76': 'culture', // 专题外链
  '78': 'enterprise', // 文旅企业
  '79': 'pavilion', // 总分馆
  '82': 'pointsmall', // 积分商城
  '108': 'workCollect', // 作品征集
  '111': 'exhibit', // 图片展览
  '112': 'recommendbook', // 图书推荐
  '113': 'museum-map', // 手绘地图
  '117': 'brandactivity' // 品牌活动
}

export default menuconfig



// WEBPACK FOOTER //
// ./src/components/header/menuconfig.js